// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";
import * as CustomErrorConverter$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/errors/CustomErrorConverter.mjs";
import * as SignupEntityMapper$PorterinFeature from "../entity-mapper/SignupEntityMapper.mjs";
import * as ResendOtpEntityMapper$PorterinFeature from "../entity-mapper/ResendOtpEntityMapper.mjs";
import * as OtpValidationEntityMapper$PorterinFeature from "../entity-mapper/OtpValidationEntityMapper.mjs";
import * as CustomerExistsEntityMapper$PorterinFeature from "../entity-mapper/CustomerExistsEntityMapper.mjs";
import * as CustomerLogoutEntityMapper$PorterinFeature from "../entity-mapper/CustomerLogoutEntityMapper.mjs";
import * as CustomerProfileEntityMapper$PorterinFeature from "../entity-mapper/CustomerProfileEntityMapper.mjs";

var execute = CustomerExistsEntityMapper$PorterinFeature.execute;

var CustomerExistsConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CustomerExistsResponseConverter = partial_arg(CustomerExistsConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

var execute$1 = SignupEntityMapper$PorterinFeature.execute;

var SignupConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SignupResponseConverter = partial_arg$1(SignupConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

var execute$2 = OtpValidationEntityMapper$PorterinFeature.execute;

var OtpValidationConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var OtpValidationResponseConverter = partial_arg$2(OtpValidationConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

var execute$3 = ResendOtpEntityMapper$PorterinFeature.execute;

var ResendOtpConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var ResendOtpResponseConverter = partial_arg$3(ResendOtpConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

var execute$4 = CustomerLogoutEntityMapper$PorterinFeature.execute;

var CustomerLogoutConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var CustomerLogoutResponseConverter = partial_arg$4(CustomerLogoutConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

var execute$5 = CustomerProfileEntityMapper$PorterinFeature.execute;

var CustomerProfileConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var CustomerProfileResponseConverter = partial_arg$5(CustomerProfileConverterConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

export {
  CustomerExistsConverterConfig ,
  CustomerExistsResponseConverter ,
  SignupConverterConfig ,
  SignupResponseConverter ,
  OtpValidationConverterConfig ,
  OtpValidationResponseConverter ,
  ResendOtpConverterConfig ,
  ResendOtpResponseConverter ,
  CustomerLogoutConverterConfig ,
  CustomerLogoutResponseConverter ,
  CustomerProfileConverterConfig ,
  CustomerProfileResponseConverter ,
}
/* CustomerExistsResponseConverter Not a pure module */
